module.exports = __webpack_public_path__ + "static/joe-b681185ee874a7039f94491c622e6c6c.jpg";